// a text search or a receipt value filter spans every date: the selected period is ignored while either is active
export function isPeriodNeutralized(params) {
    return !!params.get('search') || params.has('receiptValue[]');
}
